/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import styled, {css} from 'styled-components';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';
import Text, {FiraSansBold} from 'components/Text/Text';
import {mediaHelper} from "../../utils/src";


const propTypes = {
  isActive: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
}

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 0;
  margin: 0px 20px;
  color:${Colors.GRAY[0]};
  ${FiraSansBold}

  ${Text}{
    ${FiraSansBold}
    color:${Colors.GRAY[6]}
  }
  
  ${mediaHelper.sm`
    padding: 10px 0px 0px 0px;
    margin: 0px 0px 0px 10px;
  `}
`;

export const Section = styled.div`
  display:flex;
  flex-direction:row;
  align-items: center;
  width: auto;
  
  ${mediaHelper.sm`
    width:33%;
  `}
`;

export const Spacer = styled.div`
  border: 1px solid ${Colors.GRAY[3]};
  height: 0;
  max-height: 0;
  width: 101%;
  align-self: center;
`;

export const LayoutCircle = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items: center;
  cursor: pointer;
  
  ${({ isActive }) =>
    isActive
      ? css`
      border: 1px solid ${Colors.GRAY[5]};
      background-color: ${Colors.BLUE};
      color: ${Colors.WHITE}
      box-shadow: 0px 3px 4px -2px rgba(0,0,0,0.75);
    `
      : ` border: 1px solid ${Colors.BLUE};
      background-color: ${Colors.WHITE};
      color: ${Colors.GRAY[6]};
    `
  }
  
  ${mediaHelper.sm`
    height: 35px;
    width: 35px;
  `}
`;